import RequestManager from "../../../requests/RequestManager";
import CurrentStageTask from "../../../requests/tasks/sports/currentStageTask";
import logger from 'src/utils/logger/logger';

export default async function getCurrentStageCode (idLeague) {
    const currentStageTask = new CurrentStageTask(idLeague);
    try {
        const response = await RequestManager.addRequest(currentStageTask);
        if(!response) return null;

        const stageCode = (
            response.data &&
            response.data.stage &&
            response.data.stage.code
        ) || null

        return stageCode
    } catch (error) {
        logger.error('Error getting current stage:', error);
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/getCurrentStageCode.js